import SvgIcon from '@mui/icons-material/Menu'
import React, { useEffect, useState } from 'react'

function Rattings() {
    const dataArray=[
        {
            image:"/images/man-stretching-beach-medium-shot.png",
            name:"Hassan Malik",
            description:"As a student, the membership plans are perfect for my budget. The equipment is  fantastic, and the trainers really know their stuff. Highly recommend Fit Streak!",
        },
        {
            image:"/images/young-man-looking-away-while-standing-against-built-structure.png",
            name:"Abdul Rehman",
            description:"As a beginner, I feel totally at ease at Fit Streak. The plans are affordable, the trainers guide you every step. Perfect place to start your fitness journey!",
        },
        {
            image:"/images/woman-sportswear-holds-fitness-band-rubber-karemat-prepares-gymnastics-exersicing-stays-fit-healthy-stands-against-blurred-glass-building-urban-place.png",
            name:"jessica",
            description:"As someone passionate about fitness, Fit Streak is my go-to spot. The variety of equipment is excellent, the environment is motivating, and the trainers are always helpful. A must-try gym!",
        }
    ]
    const [data, setData] = useState([]); // Holds the data fetched from the backend
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSvg=(color:string)=>(
        <svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" className='sm:w-[40px] sm:h-[40px] w-[28px] h-[28px] ' viewBox="0 0 48 48">
    <path data-name="Path 25" d="M6.136 17.818H31.47L23.716 8.5a2.139 2.139 0 0 1 3.29-2.734l10.68 12.817a2.542 2.542 0 0 1 .192.32.271.271 0 0 0 .15.278 2.052 2.052 0 0 1 0 1.538.271.271 0 0 1-.15.278 2.542 2.542 0 0 1-.192.32l-10.68 12.821a2.139 2.139 0 1 1-3.29-2.734l7.754-9.314H6.136a2.136 2.136 0 1 1 0-4.272z" transform="translate(2.912 4.046)" style={{fill:color}}/>
    </svg>
    )
    const previousSvg=(color:string)=>(
        <svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg"  className='sm:w-[40px] sm:h-[40px] w-[28px] h-[28px] ' viewBox="0 0 48 48">
    <path data-name="Path 25" d="M36.041 17.818H10.707L18.461 8.5a2.139 2.139 0 0 0-3.29-2.734L4.491 18.587a2.542 2.542 0 0 0-.192.32.271.271 0 0 1-.15.278 2.052 2.052 0 0 0 0 1.538A.271.271 0 0 0 4.3 21a2.542 2.542 0 0 0 .192.32l10.68 12.816a2.139 2.139 0 1 0 3.29-2.734l-7.755-9.312h25.334a2.136 2.136 0 1 0 0-4.272z" transform="translate(2.911 4.046)" style={{fill:color}}/>
    </svg>
    )
    const SvgIconRattigStar=()=>(<svg xmlns="http://www.w3.org/2000/svg"  className='  w-[16px] h-[16px] xss:w-[14px] h-[14px]' viewBox="0 0 42 42">
        <defs>
            <clipPath id="dcujmxa8ya">
                <path data-name="Rectangle 8025" style={{fill:"none"}} d="M0 0h35.585v34.073H0z"/>
            </clipPath>
        </defs>
        <g data-name="Group 24822" transform="translate(3.207 3.972)" style={{clipPath:"url(#dcujmxa8ya)"}}>
            <path data-name="Path 67212" d="m26.786 12.808 9.359 1.423a1.7 1.7 0 0 1 1.423 1.922 1.628 1.628 0 0 1-.5.961l-6.812 6.566a1.679 1.679 0 0 0-.5 1.495l1.548 9.341a1.683 1.683 0 0 1-2.455 1.761l-8.363-4.466a1.631 1.631 0 0 0-1.566 0l-8.414 4.359a1.7 1.7 0 0 1-2.277-.712 1.607 1.607 0 0 1-.16-1.068l1.655-9.323a1.717 1.717 0 0 0-.48-1.495L2.5 16.919a1.67 1.67 0 0 1 0-2.384 1.7 1.7 0 0 1 .979-.48l9.377-1.3a1.71 1.71 0 0 0 1.281-.907l4.233-8.47a1.693 1.693 0 0 1 3.025.018l4.146 8.523a1.66 1.66 0 0 0 1.263.925" transform="translate(-2.001 -2.418)" style={{fill:"#ffc746"}}/>
        </g>
    </svg>
    )
    const SvgIcon=()=>(<svg xmlns="http://www.w3.org/2000/svg"  className='mt-7 xxs:mt-6 ml-2 xss:ml-4 sm:ml-8 xss:w-[38px] xss:h-[38px] w-[22px] h-[22px] xxs:w-[18px] xxs:h-[18px]   ' viewBox="0 0 42 42">
        <defs>
            <clipPath id="dcujmxa8ya">
                <path data-name="Rectangle 8025" style={{fill:"none"}} d="M0 0h35.585v34.073H0z"/>
            </clipPath>
        </defs>
        <g data-name="Group 24822" transform="translate(3.207 3.972)" style={{clipPath:"url(#dcujmxa8ya)"}}>
            <path data-name="Path 67212" d="m26.786 12.808 9.359 1.423a1.7 1.7 0 0 1 1.423 1.922 1.628 1.628 0 0 1-.5.961l-6.812 6.566a1.679 1.679 0 0 0-.5 1.495l1.548 9.341a1.683 1.683 0 0 1-2.455 1.761l-8.363-4.466a1.631 1.631 0 0 0-1.566 0l-8.414 4.359a1.7 1.7 0 0 1-2.277-.712 1.607 1.607 0 0 1-.16-1.068l1.655-9.323a1.717 1.717 0 0 0-.48-1.495L2.5 16.919a1.67 1.67 0 0 1 0-2.384 1.7 1.7 0 0 1 .979-.48l9.377-1.3a1.71 1.71 0 0 0 1.281-.907l4.233-8.47a1.693 1.693 0 0 1 3.025.018l4.146 8.523a1.66 1.66 0 0 0 1.263.925" transform="translate(-2.001 -2.418)" style={{fill:"#ffc746"}}/>
        </g>
    </svg>
    )
  // Navigate to the next slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
  };

  // Navigate to the previous slide
  const previousSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + data.length) % data.length);
  };
    useEffect(()=>(
        setData(dataArray)
    ),[])
    
    return (
    <div className='mt-6 md:mt-10 flex flex-col lg:flex-row w-full  sm:w-[96%]  lg:w-[96%] xl:w-[85%] 2xl:w-[80%] h-auto item-center justify-between m-auto'>
      <div className='flex flex-col p-10 sm:w-[80%] w-full lg:w-[45%] text-white  '>
         <h1 className='text-xl sm:text-2xl md:text-3xl lg:text-3xl 2xl:text-3xl font-bold'>What Our Happy Clients Says About Us</h1>
         <p className='text-md sm:text-lg md:text-lg lg:text-base xl:text-lg mt-10 md:mt-12 text-nav_option'>
            Hear from our members who have transformed their lives at Fit Streak. 
            Their inspiring stories showcase the impact of our programs, expert 
            trainers, and supportive community. From weight loss to muscle building, 
            our members share how they achieved their goals and found confidence 
            along the way.
         </p>
         <h1 className='text-xl mt-4 sm:text-lg md:text-xl'>What Our Happy Clients Says About Us</h1>
         <div className='flex flex-row w-full  sm:w-max item-center mt-8 justify-center'>
         <img src="/images/rattings.png" alt="ratings" className='xxs:w-[90px] w-[110px] h-auto xss:w-[180px] mt-5' />
            <div className='flex flex-row'>
            <SvgIcon/>
                <p className='xxs:text-xs text-sm xss:text-lg md:text-lg m-auto  ml-1 xss:ml-3 xss:ml-6 xxs:mt-6 mt-8 text-nav_option'>
                 4.9 (512 Reviews)
                </p>
            </div>
         </div>
      </div>
      <div className='flex flex-col p-10 w-full sm:w-[80%] item-center text-center lg:w-[45%] m-auto '>
      {data.length > 0 && (
        <div className="flex flex-col item-center bg-[#303030] py-8 px-3 md:w-[400px] m-auto rounded-[8px]">
          <div className='flex flex-row space-x-4 sm:space-x-10 w-[80%] item-center justify-start text-white font-sembold'>
           <img src={data[currentIndex].image} alt={data[currentIndex].name} className='xxs:w-[60px]'/>
           <div className='flex flex-col item-center text-left '>
           <h2 className='sm:text-lg font-semibold mt-3 text-md xxs:text-sm xxs:mt-3'>{data[currentIndex].name}</h2>
           <div className='flex flex-row  xss:space-x-1 mt-1 w-max'>
           <SvgIconRattigStar/>
           <SvgIconRattigStar/>
           <SvgIconRattigStar/>
           <SvgIconRattigStar/>
           <SvgIconRattigStar/>
           </div>
           </div>
          </div>
          <p className='font-semibold text-md text-[#bbb] text-left p-4 xxs:text-xs'>{data[currentIndex].description}</p>
        </div>
      )}
      <div className='flex flex-row justify-between mt-3 m-auto w-[180px] h-max'>
        <button
          className={`p-5 sm:p-3 rounded-full ${currentIndex===0 ? 'bg-[#303030]':"bg-red"} item-center justify-center`}
          onClick={previousSlide}
          disabled={currentIndex<=0}
        >
          {previousSvg(currentIndex===0?"#bbb":"#fff")}
        </button>
        <button
         className={`p-5 sm:p-3  rounded-full ${currentIndex>=data.length-1 ? 'bg-[#303030]':"bg-red"} item-center justify-center`}
          onClick={nextSlide}
          
          disabled={currentIndex == data.length-1}
        >
          {nextSvg(currentIndex>=data.length-1?"#bbb":"#fff")}
        </button>
      </div>
      </div>
    </div>
  )
}

export default Rattings
